import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  combineLatest,
  Subject,
  take,
  tap,
} from 'rxjs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBadgeModule } from '@angular/material/badge';
import { FacilitiesService } from '../../../../core/services/facilities.service';
import { RequestsService } from '../../../../core/services/utils/requests.service';
import { ISettingsData } from '../../settings/settings.page';
import { IUser } from '../../../../shared/models/be/user';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { NotificationService } from '../../../../core/services/notification.service';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { SharedService } from '../../../../core/services/shared.service';
import { ToastService } from '../../../../core/services/utils/toast.service';
import { isAccessTokenValid } from '../../../../shared/utils/check.utils';
import { AuthService } from '../../../../core/services/auth.service';
import { TableService } from '../../../../shared/components/table/table.service';
import { MonitoringPreferencesComponent } from '../../../../shared/components/monitoring-preferences/monitoring-preferences.component';
import { MonitoringPreferencesService } from '../../../../core/services/monitoring-preferences.service';
import { map } from 'rxjs';

@Component({
  selector: 'settingsMobile',
  templateUrl: './settings.mobile.component.html',
  styleUrls: ['./settings.mobile.component.scss'],
  imports: [
    MonitoringPreferencesComponent,
    CommonModule,
    MatGridListModule,
    MatIconModule,
    TranslateModule,
    RouterModule,
    MatGridListModule,
    MatToolbarModule,
    MatTabsModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatBadgeModule,
    IonContent
  ]
})
export class settingsMobilePage implements OnInit {
  @ViewChild(MonitoringPreferencesComponent) monitoringChecklist?: MonitoringPreferencesComponent;
  get monitoringBuildingId(): string | null {
    const user = this.requestsService.getCurrentUser();
    if (user?.role === 'superuser' && (!user.customer?.id || !user.organization?.id)) return null;
    return this.settingsData.find(section => section.id === 'building')?.inputs[0]?.selectedValue || null;
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public facilitiesService: FacilitiesService,
    private requestsService: RequestsService,
    private translate: TranslateService,
    private notificationsService: NotificationService,
    private sharedService: SharedService,
    private toastService: ToastService,
    private authService: AuthService,
    private tableService: TableService,
    private monitoringPreferences: MonitoringPreferencesService
  ) {
  }

  ionViewDidEnter() {
  }

  private destroyed$ = new Subject();
  public settingsData: ISettingsData[] = [{
    id: 'building',
    label: 'BUILDING',
    rowSpan: 2,
    inputs: [{
      id: 'building',
      type: 'select',
      length: 2,
      label: 'BUILDING',
      selectedValue: null,
      disableTranslation: true,
      touched: false,
      values: []
    }]
  }/* , {
    id: 'notifications',
    label: 'NOTIFICATIONS',
    rowSpan: 2,
    inputs: [{
      id: 'notification',
      type: 'select',
      length: 2,
      selectedValue: 'ring',
      label: 'NOTIFICATIONS',
      disableTranslation: true,
      touched: false,
      values: [{ id: 'ring', label: 'Sonoro' }, { id: 'silent', label: 'Silenzioso' }, { id: 'vibrate', label: 'Vibrazione' }],
      onSelect: (resourceId) => this.setNotificationPreference(resourceId as 'ring' | 'silent' | 'vibrate')
    }]
  } */];

  ngOnInit() {
    combineLatest([
      this.monitoringPreferences.buildings().pipe(map(result => result.buildings)),
      this.requestsService.currentUser$
    ]).pipe(
      take(1),
      tap(([buildings, currentUser]) => {
        let buildingSection = buildings && this.settingsData.find((section) => section.id === 'building')
        let languageSection = currentUser && this.settingsData.find((section) => section.id === 'language')
        if (buildingSection) {
          buildingSection.inputs[0].selectedValue = currentUser?.building?.id || null,
            buildingSection.inputs[0].values = buildings.map((building) => ({ id: building.id!, label: building.name! })) || [],
            buildingSection.inputs[0].onSelect = (resourceId) => {
              currentUser = {
                ...currentUser as IUser,
                building: {
                  id: buildings.find((building) => building.id === resourceId)?.id || '',
                  name: buildings.find((building) => building.id === resourceId)?.name || ''
                }
              };
              this.sharedService.stopWss();
              this.requestsService.saveCurrentUser(currentUser);
              this.tableService.clearTableFilters('alertsHistory', ['room', 'unit']);
              this.notificationsService.checkNotificationPermission();
              this.sharedService.clearAlerts();
              if (isAccessTokenValid()) {
                this.sharedService.startWss(this.toastService);
              } else {
                this.authService.callRefreshToken$().pipe(
                  tap(() => this.sharedService.startWss(this.toastService))
                ).subscribe();
              }
            }
        }
        if (languageSection) {
          languageSection.inputs[0].selectedValue = currentUser?.language || 'it';
        }
      })
    ).subscribe();
  }

  setNotificationPreference(mode: 'ring' | 'silent' | 'vibrate') {
    let currentUser = this.requestsService.getCurrentUser();
    currentUser && (currentUser.notificationPreference = mode)
    this.requestsService.saveCurrentUser(currentUser)
  }

  async saveData() {
    if (this.monitoringChecklist && !await this.monitoringChecklist.saveIfNeeded()) return;
    this.settingsData.forEach((section) => {
      if (section.inputs[0].touched) {
        section.inputs[0].onSelect!(section.inputs[0].selectedValue!)
      }
    });
    this.router.navigateByUrl("");
  }

  ngOnDestroy() {
    this.destroyed$.next(1);
    this.destroyed$.complete();
  }
}
